<div class="containar-layout team-section" *ngIf="teamMemberDetails.length">
  <table class="table-section">
    <thead>
      <tr>
        <th class="column-head custom-border">Team Member <span class="sort-icon" (click)="sortTeamMembers()"><i
              class="fa fa-sort" style="color: #32455f;"></i></span></th>
        <th class="column-head" *ngFor="let teamShiftDetail of teamMemberDetails[0]?.memberSchedules">
          {{teamShiftDetail?.dateStr | weekMonthDate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let shiftDetail of teamMemberDetails">
        <td class="column-body"><ng-container *ngTemplateOutlet="teamHeader; context: {shiftDetail: shiftDetail}"></ng-container></td>
        <td class="column-body" *ngFor="let teamShiftDetail of shiftDetail?.memberSchedules">
          <app-team-member-slot-card (addTimeOffEmitter)="openAddTimeOffPopup($event)"
            (editSlotOffEmitter)="openEditSlotPopup($event)" (cancelLeaveEmitter)="cancelLeave($event)"
            [teamShiftDetail]="teamShiftDetail" [providerId]="shiftDetail?.providerId" [teamName]="shiftDetail"
            [team]="teamShiftDetail.userTeams" [isPastDate]="isPastDate"
            [id]="shiftDetail?.id"></app-team-member-slot-card>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="no-records-wrapper" *ngIf="!teamMemberDetails.length">No records available</div>

<ng-template #teamHeader let-shiftDetail ="shiftDetail">
  <div class="team-header-wrappper">
    
    <div class="user-info">
      <span class="user-image">
        <img
          src="/assets/images/temp/web-user.svg"
          alt="web user"
          *ngIf="shiftDetail.userType === 'Web'"
        />
        <img
          src="/assets/images/temp/mobile-user.svg"
          alt="mobile user"
          *ngIf="shiftDetail.userType === 'Mobile'"
        />
      </span>
      <span class="user-details">
        <h4 class="title-heading">
          {{ shiftDetail.firstName }} {{ shiftDetail.lastName }}
          <span *ngIf="shiftDetail.userType === 'Web'" class="showrole">({{ shiftDetail.roleName }})</span>
        </h4>
      </span>
    </div>
    
    <div class="icon" (click)="addDeleteShift(shiftDetail.userId, shiftDetail.providerId, shiftDetail.firstName, shiftDetail.lastName, shiftDetail.userType)" *ngIf="(shiftDetail.userType === 'Mobile' && !organizationLevelShift && !providerArr.includes(shiftDetail.providerId) && !teamDOOArr.includes(shiftDetail?.memberSchedules[0]?.userTeams[0]?.teamId)) || (shiftDetail.userType === 'Web')">
      <img src="/assets/images/temp/bulk-schedule-icon.svg" alt="Bulk schedule icon" />
    </div>
  </div>
</ng-template>

<p-dialog [blockScroll]="true" modal="true" [showHeader]="false" position="center" responsive="true"
  styleClass="medium-popup" [(visible)]="showAddTimeOffPopup" [style]="{width: '450px', height: 'auto'}"
  responsive="true">
  <app-add-time-off-modal *ngIf="showAddTimeOffPopup" (closeAddTimeOffEmitter)="closeAddTimeOffPopup($event)"
    [addTimeOffDetails]="addTimeOffDetails"></app-add-time-off-modal>
</p-dialog>

<p-dialog class="manage-pop-shift" [blockScroll]="true" modal="true" [showHeader]="false" position="center"
  responsive="true" [style]="{width: '650px', height: 'auto',overflow: 'auto'}" styleClass="add-routes-popup" [(visible)]="showEditPopup"
  responsive="true" ng-style="overflow: auto" [contentStyle]="{'overflow':'auto'}">
  <app-manage-shift-details *ngIf="showEditPopup" (publishOpenShiftEmitter)="onClickOfPopupButton($event)"
    [shiftDetails]="editSlotDetails"></app-manage-shift-details>
</p-dialog>

<p-confirmDialog [style]="{width: '460px'}" [acceptLabel]="'Yes'" [rejectLabel]="'No'">
</p-confirmDialog>
